import { useEffect, useState } from "react";
import BasicTable from "../../components/table";
import { api } from "../../services/axios";
import { AddModal } from "./styles";

import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  Autocomplete,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import Modal from "react-modal";
import { ModalAlert } from "../../components/modal";
import { ModalAlertDiv } from "../../components/modal/style";
import { TableBar } from "../../components/table/styles";

import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { newDateFormat } from "../../components/date";
import PercentIcon from "@mui/icons-material/Percent";
import { Delete } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import PhoneField from "../../components/phoneInput";
const EditUser = () => {
  const url = "core/ajax/manager.users";

  const headers = [
    { label: "E-mail/UID", value: "email" },
    { label: "Availability Email Verified", value: "emailVerified" },
    { label: "Enable/Disable", value: "enableDisable" },
    { label: "PasswordUpdatedAt", value: "passwordUpdatedAt" },
    { label: "Dias para trocar Senha", value: "CreateDate" },
    { label: "bloqueio/desativa	=", value: "engineActive" },
    // { label: "Tags", value: "customClaims" },
    { label: "Actions", value: "Actions" },
  ];

  const [rows, setRows] = useState({
    default: [],
    filter: [],
  });

  const [showModal, setShowModal] = useState(false);
  const [showModalTags, setShowModalTags] = useState(false);
  const [phone, setPhone] = useState("");
  const [form, setForm] = useState(defaultForm);
  const [alert, setAlert] = useState({ msg: "", status: undefined });
  const [showAlert, setShowAlert] = useState(false);
  const [id, setId] = useState();
  const [txt, setTxt] = useState();
  const [tags, setTags] = useState([]);
  const [examples, setExamples] = useState([
    { label: "resetpass", value: "" },
    { label: "company", value: "" },
    { label: "campaigns", value: "" },
    { label: "country", value: "" },
    { label: "asb_admin", value: "" },
    { label: "asb_reporting", value: "" },
    { label: "asb_dam", value: "" },
    { label: "asb_blacklist", value: "" },
    { label: "asb_calendars", value: "" },
    { label: "asb_campaigns", value: "" },
    { label: "asb_dashboard", value: "" },
    { label: "asb_docs", value: "" },
    { label: "asb_engine", value: "" },
    { label: "asb_facebook", value: "" },
    { label: "asb_pools", value: "" },
    { label: "asb_products", value: "" },
    { label: "asb_providers", value: "" },
    { label: "asb_segmentations", value: "" },
    { label: "asb_system", value: "" },
    { label: "asb_transformers", value: "" },
    { label: "asb_typifications", value: "" },
    { label: "asb_warnings", value: "" },
    { label: "asb_sms", value: "" },
    { label: "asb_available", value: "" },
    { label: "asb_config", value: "" },
    { label: "asb_users", value: "" },
    { label: "asb_project", value: "" },
    { label: "sso_admin", value: "" },
    { label: "sso_locked", value: "" },
    { label: "sso_site_admin", value: "" },
  ]);

  useEffect(() => {
    listUpdate();
  }, []);

  const listUpdate = () => {
    api
      .post(url, {
        type: "listUsers",
        authx: '',
      })
      .then(function (res) {
        // process.env.REACT_APP_BASE_URL === '/' ?
        setRows({
          default: res.data.msg,
          filter: res.data.msg,
        }) 
        // :
        // setRows({
        //   default: test,
        //   filter: test,
        // })
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const updateForm = (row, type) => {
    const json = jsonToArray(row.customClaims);
    setForm({
      email: row.email,
      uid: row.uid,
      phoneNumber: row.phoneNumber,
      emailVerified: row.emailVerified,
      customClaims: row.customClaims,
    });
    setPhone(row.phoneNumber.replace(/\D/g, ""));
    setTags(json);
    setExamples(
      examples.filter(
        (ex) => !json.filter((js) => js.label === ex.label).length
      )
    );
    setId(row.uid);
    type === "tags" ? setShowModalTags(true) : setShowModal(true);
  };

  function mergeJSONs(arrayOfJSONs) {
    const arr = arrayOfJSONs.map((e) => {
      return { [e.label]: e.value };
    });

    // Inicializa um objeto vazio para armazenar o resultado
    var mergedJSON = {};

    // Itera sobre cada JSON no array
    arr.forEach(function (json) {
      // Itera sobre as chaves do JSON atual
      for (var key in json) {
        // Verifica se a chave pertence ao objeto atual e não aos protótipos
        if (json.hasOwnProperty(key)) {
          // Adiciona a chave e valor ao objeto mergedJSON
          mergedJSON[key] = json[key];
        }
      }
    });

    // Retorna o objeto JSON resultante
    return mergedJSON;
  }

  const confirmUpdateForm = (type) => {
    const customClaims = JSON.stringify(mergeJSONs(tags));

    console.log(customClaims);

    const casePhone = {
      user: id,
      value: "+" + phone,
      properties: "phoneNumber",
      type: "updateData",
    };

    const caseTags = {
      uid: id,
      custom: customClaims,
      type: "setCustomUserClaims",
    };

    // if (type === "changePhone") console.log(casePhone);
    if (type === "changeTags") console.log(caseTags);

    api
      .post(url, type === "changePhone" ? casePhone : caseTags)
      .then(function (res) {
        setAlert(res.data);
        listUpdate();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxHeight: "90%",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
    },
  };

  const jsonToArray = (jsonData) => {
    // Inicializa um array vazio para armazenar os resultados
    var resultArray = [];

    // Itera sobre as chaves do objeto JSON
    for (var key in jsonData) {
      // Verifica se a chave realmente pertence ao objeto e não aos protótipos
      if (jsonData.hasOwnProperty(key)) {
        // Adiciona um objeto com chave e valor ao array de resultados
        if (typeof jsonData[key] == "boolean") {
          resultArray.push({
            label: key,
            value: jsonData[key] ? "true" : "false",
          });
        } else {
          resultArray.push({ label: key, value: jsonData[key] });
        }
      }
    }
    // Retorna o array resultante
    return resultArray;
  };

  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return (
        row.email?.includes(e.target.value.toLowerCase()) ||
        row.passwordUpdatedAt?.toString().includes(e.target.value) ||
        row.phoneNumber?.includes(e.target.value) ||
        row.passwordUpdatedAt?.date?.includes(e.target.value)
      );
    });
    setRows({ ...rows, filter });
  };

  const resetPass = (row) => {
    api
      .post(url, {
        type: "resetPasswd",
        authx: '',
        user: row.email
      })
      .then(function (res) {
        window.open(res.data, '_blank');
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const changeUserStatus = (row, actionType) => {
    api
      .post(url, "type=" + actionType + "&authx=undefined&ID=" + row.uid)
      .then(function (res) {
        setAlert(res.data);
        listUpdate();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleEnableDisable = (row) => {
    const actionType = row?.disabled ? "enable" : "disable";
    changeUserStatus(row, actionType);
  };

  const handleUserCheckUncheck = (row) => {
    const actionType = row?.emailVerified ? "useruncheck" : "usercheck";
    changeUserStatus(row, actionType);
  };

  return (
    <TableBar>
      <h1>EditUser</h1>
      <div className="buttons">
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <BasicTable
        type={"users"}
        headers={headers}
        rowsProps={rows.filter}
        updateForm={updateForm}
        resetPass={resetPass}
        handleEnableDisable={handleEnableDisable}
        handleUserCheckUncheck={handleUserCheckUncheck}
        onDelete={() => { }}
        handleActive={() => { }}
        updateEngine={""}
      />

      {/* Modal de Editar Usuario */}
      <Modal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
          setForm(defaultForm);
          setTags([]);
        }}
        style={customStyles}
        ariaHideApp={false}
      >
        <h1>EditUser</h1>
        <Divider sx={{ m: "1.2rem 0" }} variant="middle" />
        <AddModal>
          <div className="fields">
            <TextField
              disabled
              label="Uid"
              variant="outlined"
              sx={{ width: "100%", mb: 1 }}
              value={form.uid}
              onChange={(e) => {
                setForm({
                  ...form,
                  url: e.target.value,
                });
              }}
            />

            <TextField
              disabled
              label="Email"
              variant="outlined"
              sx={{ width: "100%", mb: 1 }}
              value={form.email}
              onChange={(e) => {
                setForm({
                  ...form,
                  name: e.target.value,
                });
              }}
            />
            {/* 
            <TextField
              label="Phone Number"
              variant="outlined"
              sx={{ width: "18rem" }}
              value={form.phoneNumber}
              multiline
              onChange={(e) => {
                setForm({
                  ...form,
                  description: e.target.value,
                });
              }}
            /> */}
            <PhoneField
              disabled={true}
              value={form.phoneNumber}
              defaultCountry={"br"}
              onChange={(e) => console.log(e)}
            />

            <PhoneField
              value={form.phoneNumber}
              defaultCountry={"br"}
              onChange={(e) => setPhone(e)}
            />

            <Button
              sx={{ marginTop: "1rem" }}
              fullWidth
              onClick={() => {
                confirmUpdateForm("changePhone");
              }}
              variant="contained"
            >
              Change Phone
            </Button>
          </div>
        </AddModal>
      </Modal>

      {/* Modal de Editar Tags */}
      <Modal
        isOpen={showModalTags}
        onRequestClose={() => {
          setShowModalTags(false);
          setForm(defaultForm);
          setTags([]);
        }}
        style={customStyles}
        ariaHideApp={false}
      >
        <h1>Tags</h1>

        <AddModal>
          {tags.map((e, index) => {
            return (
              <Stack
                spacing={2}
                sx={{ width: "100%", mb: 1 }}
                direction="row"
                alignItems="center"
                key={index}
              >
                <TextField
                  label={e.label}
                  variant="outlined"
                  sx={{ width: "100%" }}
                  defaultValue={e.value}
                  multiline
                  onChange={(txt) => {
                    const newArr = tags;
                    newArr[index] = { label: e.label, value: txt.target.value };
                    setTags(newArr);
                  }}
                />

                <IconButton
                  variant="contained"
                  onClick={() => {
                    setExamples((prev) => [...prev, e]);
                    setTags(
                      tags.filter((item) => {
                        return item.label !== e.label;
                      })
                    );
                  }}
                >
                  <Delete />
                </IconButton>
              </Stack>
            );
          })}
          <Stack spacing={2} width={"100%"} direction="row" alignItems="center">
            <Autocomplete
              clearOnEscape
              sx={{ flex: "1" }}
              size="medium"
              className={"type"}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) =>
                value === undefined ||
                value === "" ||
                option === value ||
                tags.includes(option)
              }
              options={examples}
              value={txt}
              onChange={(event, value) => {
                setTxt(value);
              }}
              renderInput={(params) => <TextField {...params} label="Fields" />}
            />

            <IconButton
              variant="contained"
              onClick={() => {
                setExamples(
                  examples.filter((e) => {
                    return e.label !== txt.label;
                  })
                );

                if (txt !== "") {
                  setTags((prev) => [...prev, txt]);
                  setTxt(undefined);
                }
              }}
            >
              <AddIcon />
            </IconButton>
          </Stack>
          <Button
            sx={{ marginTop: "1rem" }}
            fullWidth
            onClick={() => {
              confirmUpdateForm("changeTags");
            }}
            variant="contained"
          >
            Update
          </Button>
        </AddModal>
      </Modal>

      {/* Modal de Alerta */}
      <ModalAlert
        showModal={showAlert}
        onClose={() => {
          setShowAlert(!showAlert);
          setAlert({ msg: "", status: undefined });
        }}
        onClickOutside={false}
      >
        {alert.status === undefined ? (
          <ModalAlertDiv>
            <CircularProgress />
            <h1> {showModal ? "Updating " : "Updating engine"}</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
        ) : alert.status === "ok" ? (
          <ModalAlertDiv>
            <CheckCircleOutlineOutlinedIcon
              color={"success"}
              style={{ fontSize: "4rem" }}
            />
            <h1>Success!</h1>

            <Button
              onClick={() => {
                setShowAlert(false);
              }}
              variant="contained"
            >
              Ok
            </Button>
          </ModalAlertDiv>
        ) : (
          <ModalAlertDiv>
            <h2>Error code {alert.code}</h2>
            <h3>:&#40; </h3>
            <p>{alert.msg}</p>
          </ModalAlertDiv>
        )}
      </ModalAlert>
    </TableBar>
  );
};

export default EditUser;

const tet = [
  { label: "resetpass", value: "" },
  { label: "company", value: "" },
  { label: "campaigns", value: "" },
  { label: "countryBR1", value: "" },
  { label: "asb_admin", value: "" },
  { label: "asb_reporting", value: "" },
  { label: "asb_dam", value: "" },
  { label: "asb_blacklist", value: "" },
  { label: "asb_calendars", value: "" },
  { label: "asb_campaigns", value: "" },
  { label: "asb_dashboard", value: "" },
  { label: "asb_docs", value: "" },
  { label: "asb_engine", value: "" },
  { label: "asb_facebook", value: "" },
  { label: "asb_pools", value: "" },
  { label: "asb_products", value: "" },
  { label: "asb_providers", value: "" },
  { label: "asb_segmentations", value: "" },
  { label: "asb_system", value: "" },
  { label: "asb_transformers", value: "" },
  { label: "asb_typifications", value: "" },
  { label: "asb_warnings", value: "" },
  { label: "asb_sms", value: "" },
  { label: "asb_available", value: "" },
  { label: "asb_config", value: "" },
  { label: "asb_users", value: "" },
  { label: "asb_project", value: "" },
  { label: "sso_admin", value: "" },
  { label: "sso_locked", value: "" },
  { label: "sso_site_admin", value: "" },
];

const defaultForm = {
  email: "",
  uid: "",
  phoneNumber: "",
  emailVerified: "",
  customClaims: "",
};

const test = [
  {
    email: "tainah.zucco@telefonica.com",
    phoneNumber: "+5511911409236",
    uid: "01cVw8RXvNhBYWYsm0v8jSieGEJ3",
    emailVerified: true,
    customClaims: {
      company: "1",
      campaigns: "344",
      country: "BR1",
      asb_reporting: true,
      resetpass: true,
    },
    passwordUpdatedAt: {
      date: "2024-01-15 14:47:32.648000",
      timezone_type: 3,
      timezone: "America/Sao_Paulo",
    },
  },
  {
    email: "Jorge.zucco@telefonica.com",
    phoneNumber: "+5511911409236",
    uid: "01cVw8RXvNhBYWYsm0v8jSieGEJ3",
    emailVerified: true,
    customClaims: {
      company: "1",
      campaigns: "344",
      country: "BR1",
      asb_reporting: true,
      resetpass: true,
    },
    passwordUpdatedAt: {
      date: "2024-01-16 14:47:32.648000",
      timezone_type: 3,
      timezone: "America/Sao_Paulo",
    },
  },
  {
    email: "Jeff.zucco@telefonica.com",
    phoneNumber: "+5511911409236",
    uid: "01cVw8RXvNhBYWYsm0v8jSieGEJ3",
    emailVerified: true,
    customClaims: {
      company: "1",
      campaigns: "344",
      country: "BR1",
      asb_reporting: true,
      resetpass: true,
    },
    passwordUpdatedAt: {
      date: "2024-01-17 14:47:32.648000",
      timezone_type: 3,
      timezone: "America/Sao_Paulo",
    },
  },
];
